    document.addEventListener("DOMContentLoaded", () => {

        var images = document.querySelectorAll('img.lazy');
        var lazyVideos = document.querySelectorAll('video.lazy');
        var pictures = document.querySelectorAll('picture.lazy > source');
        var lazyBgs = document.querySelectorAll('.lazy-bg');

        if (!('IntersectionObserver' in window)) {
            for (var image in images) {
                handleImage(images[image]);
            }
            for (var video in videos) {
                video.play();
            }

            pictures.forEach(function (image) {
                image.nextElementSibling.src = image.nextElementSibling.dataset.srcset;
            });

        } else {
            var config = {
                rootMargin: '100px 0px',
                threshold: 0.01
            };
            var imageObserver = new IntersectionObserver(observeImages, config);

            for (var i = 0; i < images.length; i++) {
                imageObserver.observe(images[i]);
            }

            function observeImages(entries) {
                for (var i = 0; i < entries.length; i++) {
                    var entry = entries[i];
                    if (entry.intersectionRatio > 0) {
                        imageObserver.unobserve(entry.target);
                        handleImage(entry.target);
                    }
                }
            }

            var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (video) {
                    if (video.isIntersecting) {
                        for (var source in video.target.children) {
                            var videoSource = video.target.children[source];
                            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                                videoSource.src = videoSource.dataset.src;
                            }
                        }

                        video.target.load();
                        video.target.classList.remove("lazy");
                        lazyVideoObserver.unobserve(video.target);
                    }
                });
            });

            lazyVideos.forEach(function (lazyVideo) {
                lazyVideoObserver.observe(lazyVideo);
            });

            //function observeVideos(entries) {
            //    for (var i = 0; i < entries.length; i++) {
            //        var entry = entries[i];
            //        var video = entry.target;
            //        if (entry.intersectionRatio > 0 && video.paused) {
            //            video.play();
            //        } else {
            //            video.pause();
            //        }
            //    }
            //}

            _bgImgObserver = new IntersectionObserver(observeBgImgs, config);

            function observeBgImgs(entries) {
                for (var i = 0; i < entries.length; i++) {
                    var entry = entries[i];
                    var el = entry.target;

                    if (entry.intersectionRatio > 0) {
                        _bgImgObserver.unobserve(entry.target);
                        handleImage(entry.target);
                    }
                }
            }

            //_videoObserver = new IntersectionObserver(observeVideos, config);
            //for (var i = 0; i < videos.length; i++) {
            //    _videoObserver.observe(videos[i]);
            //}

            _pictureObserver =
                new IntersectionObserver(function (entries, observer) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            let lazyImage = entry.target;
                            lazyImage.srcset = lazyImage.dataset.srcset;
                            lazyImage.nextElementSibling.srcset = lazyImage.dataset.srcset;
                            lazyImage.nextElementSibling.classList.add('fade-in');
                            lazyImage.parentElement.classList.remove("lazy");
                            _pictureObserver.unobserve(lazyImage);
                        }
                    });
                });

            pictures.forEach(function (lazyImage) {
                _pictureObserver.observe(lazyImage);
            });

            for (var i = 0; i < lazyBgs.length; i++) {
                _bgImgObserver.observe(lazyBgs[i]);
            }

        }

        function handleImage(el) {
            preloadImage(el.dataset.src).then(function (src) {
                el.tagName === 'IMG' ? el.src = src : el.style.backgroundImage = 'url(' + src + ')';
                el.classList.add('fadeIn');
                el.removeAttribute('data-src');
            });
        }

        function preloadImage(url) {
            return new Promise(function (resolve, reject) {
                var image = new Image();
                image.load = resolve(url);
                image.error = reject;
                image.src = url;
            });
        }
    });